import client from "./client";

export const advanceEligibility = async () => (await client.get("/hr/advances/eligibility")).data;
export const requestAdvance = async (body) => (await client.post("/hr/advances", body)).data;
export const resignationPolicy = async () => (await client.get("/hr/resignations/policy")).data;
export const submitResignation = async (body) => (await client.post("/hr/resignations", body)).data;
export const myRequests = async () => (await client.get("/hr/my-requests")).data;
export const hrRequests = async (status = "pending") =>
  (await client.get("/hr/requests", { params: { status } })).data;
export const pendingApprovalsCount = async () => (await client.get("/hr/requests/pending-count")).data;
export const decideRequest = async (kind, id, action, note) =>
  (await client.post(`/hr/${kind}/${id}/${action}`, { note })).data;
export const resumeLeave = async (id) => (await client.post(`/hr/leaves/${id}/resume`)).data;
export const approveResumeLeave = async (id, approve, note) =>
  (await client.post(`/hr/leaves/${id}/approve-resume`, { approve, note })).data;
export const branchCalendar = async (branchId, month) =>
  (await client.get(`/branches/${branchId}/calendar`, { params: { month } })).data;
